module.exports = __webpack_public_path__ + "img/epson.9d2a6b01.jpg";